import React from "react";
import {
  ActivityCalendar,
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../../components";

const Activities = ({ isOpen, onClose }) => {
  //   const { formData, errors, handleChange, validateAllFields } = useFormHandler({
  //     filter1: "",
  //     filter2: "",
  //   });

  //   console.log("isOpen", isOpen);
    const sampleData = [
      {
        date: "2024-11-28",
        time: "09:00",
        title: "Green Card",
        description: "Richa Sarkar  |  EMP-1041 |  richa@tektreeinc.com",
      },
      {
        date: "2024-12-10",
        time: "14:30",
        title: "Green Card",
        description: "Richa Sarkar  |  EMP-1041 |  richa@tektreeinc.com",
      },
      {
        date: "2025-01-10",
        time: "11:45",
        title: "Green Card",
        description: "Richa Sarkar  |  EMP-1041 |  richa@tektreeinc.com",
      },
    ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Activities"
      width="max-w-6xl"
    >
      <div>
        {/* <div className="flex justify-end mb-2">
          <div className="grid grid-cols-3 max-w-7xl gap-x-6 items-end mb-2 items-right">
            <FormFieldSet
              type="datepicker"
              title={""}
              placeholder="MM/DD/YYYY"
              value={formData.filter1}
              onChange={(value) => handleChange("filter1", value)}
              error={errors.filter1}
            />
            <FormFieldSet
              type="datepicker"
              title={""}
              placeholder="MM/DD/YYYY"
              value={formData.filter2}
              onChange={(value) => handleChange("filter2", value)}
              error={errors.filter2}
            />
            <div className="mt-5">
              <Button title={"Filter"} />
            </div>
          </div>
        </div> */}
        <ActivityCalendar data={sampleData} />
      </div>
    </Modal>
  );
};

export default Activities;
